
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { RetentionPolicyFormValues } from '../schemas/retentionPolicySchema';

interface TableNameFieldProps {
  form: UseFormReturn<RetentionPolicyFormValues>;
}

export function TableNameField({ form }: TableNameFieldProps) {
  return (
    <FormField
      control={form.control}
      name="table_name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Table Name</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value || "certificates"}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a table" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="certificates">certificates</SelectItem>
              <SelectItem value="certificate_reports">certificate_reports</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            Select the table this retention policy applies to
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
